export let authStateData = {
  loading: false,
  error: false,
  success: false,
  message: "",
  accessToken: null,
};
